import { DOMParser, XMLSerializer, onErrorStopParsing } from '@xmldom/xmldom'

export function crearErrorDocx(code, message, detail = {}) {
  const error = new Error(message)
  error.code = code
  error.detail = detail
  return error
}

export function parsearXmlDocx(xml, partName) {
  if (typeof xml !== 'string' || xml.trim() === '') {
    throw crearErrorDocx('docx_xml_empty', 'La parte XML del DOCX está vacía', { partName })
  }

  try {
    const documento = new DOMParser({ onError: onErrorStopParsing }).parseFromString(
      xml,
      'application/xml'
    )

    if (!documento?.documentElement) {
      throw crearErrorDocx('docx_xml_root_missing', 'La parte XML no tiene elemento raíz', {
        partName,
      })
    }

    return documento
  } catch (error) {
    if (error?.code) throw error
    throw crearErrorDocx('docx_xml_invalid', 'La parte XML del DOCX no es válida', {
      partName,
      cause: error?.message || String(error),
    })
  }
}

export function serializarXmlDocx(documento) {
  return new XMLSerializer().serializeToString(documento)
}

export function elementosPorNombreLocal(documento, namespaceURI, localName) {
  return Array.from(documento.getElementsByTagNameNS(namespaceURI, localName))
}

export function comprobarRaiz(documento, namespaceURI, localName, partName) {
  const raiz = documento.documentElement
  if (raiz.namespaceURI !== namespaceURI || raiz.localName !== localName) {
    throw crearErrorDocx('docx_xml_root_invalid', 'La parte XML tiene un elemento raíz inesperado', {
      partName,
      expectedNamespace: namespaceURI,
      expectedLocalName: localName,
      actualNamespace: raiz.namespaceURI,
      actualLocalName: raiz.localName,
    })
  }
  return raiz
}
